<template>
  <div id="pageDashboard">
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg4 sm4 xs12>
            <h4 class="pl-1">Join Date: <b>{{joinDate}}</b></h4>
          </v-flex>
          <v-flex lg4 sm4 xs12>
            <h4 class="pl-1">PPN: <b>{{ !ppn || ppn === '_' ? 'Not found' : ppn }}</b></h4>
          </v-flex>
          <v-flex lg4 sm4 xs12 class="flex-start">
            <h4 class="pl-1">Membership: <b>{{membership}}</b></h4>
            <v-menu offset-y :close-on-content-click="false" left>
              <template v-slot:activator="{ on }">
                <v-btn icon small class="mr-0 ml-1" v-on="on">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                  <v-icon size="22" color="teal" v-on="on">more_vert</v-icon>
                  </template>
                    <span>Actions</span>
                  </v-tooltip>
                </v-btn>
              </template>
              <v-list class="familyOptions">
                <v-list-tile :href="`${config.host}membership-account/membership-levels/`" v-if="membership === 'Network' && !session.getSession().adminUser">
                  <v-list-tile-content>
                    <v-list-tile-title >
                      Upgrade Membership
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-group
                  v-else-if="membership === 'Network' && session.getSession().adminUser"
                  no-action
                >
                  <template v-slot:activator>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>Upgrade Membership</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>

                  <v-list-tile @click="upgradeMembership('Featured')" v-if="true">
                    <v-list-tile-title class="pf-menu-text">- Featured</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="upgradeMembership('Preferred')" v-if="true">
                    <v-list-tile-title class="pf-menu-text">- Preferred</v-list-tile-title>
                  </v-list-tile>

                </v-list-group>
                <!-- <v-list-tile v-else-if="membership === 'Network' && session.getSession().adminUser">
                  <v-list-tile-content>
                    <v-menu
                      transition="slide-y-transition"
                      bottom
                    >
                      <template v-slot:activator="{ on }">
                        <a v-on="on">Upgrade Membership</a>
                      </template>
                      <v-list>
                        <v-list-tile @click="upgradeMembership('Featured')" v-if="true">
                          <v-list-tile-title class="pf-menu-text">Featured</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="upgradeMembership('Preferred')" v-if="true">
                          <v-list-tile-title class="pf-menu-text">Preferred</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-list-tile-content>
                </v-list-tile> -->
                <v-list-tile @click="cancelMembership" v-if="IsSubscriptionActive">
                  <v-list-tile-content>
                    <v-list-tile-title >
                      Cancel Subscription
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile @click="addNewCard" v-if="IsSubscriptionActive">
                  <v-list-tile-content>
                    <v-list-tile-title >
                      Add Credit Card
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
    </v-container>

    <v-container grid-list-xl fluid py-0>
      <v-layout row wrap>
        <!-- <v-flex sm6 md4 xs12 :class="membership === 'Network' ? 'mb-4 lg2': 'mb-4 lg3'"> -->
        <v-flex sm6 md4 xs12 class="mb-4" v-if="isWidgetActive('PDFProfile')">
           <router-link to="/pdfTemplate">
           <v-card hover>
            <v-layout>
              <v-flex>
                <v-card-text>
                  <div class="icon">
                    <v-icon large :class="{ 'pf-text-green': PdfTemplate.length, 'pf-text-red': !PdfTemplate.length }">file_copy</v-icon>
                  </div>
                  <h4>PDF Profile</h4>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-card>
          </router-link>
        </v-flex>
        <v-flex sm6 md4 xs12 class="mb-4" v-if="isWidgetActive('Flipbook')">
          <router-link to="/flipbook">
          <v-card hover>
            <v-layout>
              <v-flex>
                <v-card-text>
                  <div xs6 class="icon">
                    <v-icon large :class="{ 'pf-text-green': Account.flipbook && Account.flipbook.length, 'pf-text-red': !Account.flipbook || !Account.flipbook.length }">menu_book</v-icon>
                  </div>
                  <h4 xs6>Flipbook</h4>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-card>
          </router-link>
        </v-flex>
        <v-flex sm6 md4 xs12 class="mb-4" v-if="isWidgetActive('Views')">
          <router-link to="/views">
            <v-card hover>
              <v-layout>
                <v-flex>
                  <v-card-text>
                    <div xs6 class="icon">
                      <v-icon large :class="{ 'pf-text-green': Account.views, 'pf-text-red': !Account.views }">visibility</v-icon>
                    </div>
                    <h4 xs6>Views: <span>{{ Account.views }}</span></h4>
                  </v-card-text>
                </v-flex>
              </v-layout>
            </v-card>
          </router-link>
        </v-flex>
        <!-- <v-flex lg3 sm6 md4 xs12 class="mb-4" v-if="membership !== 'Network'">
          <router-link :to="Account.template && Account.template.template ? `/templates/${Account.template.template.id}` : '/templates'">
          <v-card hover>
            <v-layout>
              <v-flex>
                <v-card-text>
                  <div xs6 class="icon">
                    <v-icon large :class="Account.template && Account.template.template && Account.template.template.id ? 'pf-text-green' : 'pf-text-red'">photo_library</v-icon>
                  </div>
                  <h4 xs6 class="text-truncate">{{ Account.template && Account.template.template ? Account.template.template.name : 'Theme' }}</h4>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-card>
          </router-link>
        </v-flex> -->
        <v-flex sm6 md4 xs12 class="mb-4" v-if="isWidgetActive('WebsiteConfiguration') && Account.membership && Account.membership !== 'Network'">
          <div @click="templateClick">
          <v-card hover :class="{ 'disabled': !(Account.agency && Account.agency.length && Account.agency.filter(x => x.status === 'Active').length) }">
            <v-layout>
              <v-flex>
                <v-card-text>
                  <div xs6 class="icon">
                    <v-icon large :class="Account.website_template ? 'pf-text-green' : 'pf-text-red'">web</v-icon>
                  </div>
                  <h4 xs6 class="text-truncate">{{ Account.website_template && Account.website_template.name ? Account.website_template.name : 'Website Configuration' }}</h4>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-card>
          </div>
        </v-flex>
        <v-flex sm6 md4 xs12 class="mb-4" v-if="isWidgetActive('Files')">
          <router-link to="/files">
            <v-card hover>
              <v-layout>
                <v-flex>
                  <v-card-text>
                    <div xs6 class="icon">
                      <v-icon large :class="{ 'pf-text-green': File.length, 'pf-text-red': !File.length }">cloud</v-icon>
                    </div>
                    <h4 xs6>Files: <span>{{ File.length }}</span></h4>
                  </v-card-text>
                </v-flex>
              </v-layout>
            </v-card>
          </router-link>
        </v-flex>
        <v-flex sm6 md4 xs12 class="mb-4" v-if="isWidgetActive('HelpVideos')">
          <router-link to="/helpVideos">
          <v-card hover>
            <v-layout>
              <v-flex>
                <v-card-text>
                  <div xs6 class="icon">
                    <v-icon large :class="{ 'pf-text-green': helpVideoList.length, 'pf-text-red': !helpVideoList.length }">video_library</v-icon>
                  </div>
                  <h4 xs6>Help Videos</h4>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-card>
          </router-link>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex lg4 sm6 xs12 class="mb-4" v-if="isWidgetActive('Tasks')">
          <v-card hover>
            <v-card-title class="justify-space-between pf-bg-pink white--text">
              <h4 xs6>Tasks</h4>
              <div xs6 class="icon">
                <v-icon large color="white">list</v-icon>
              </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="tasks-card-text">
              <v-bottom-nav
                :active.sync="filterTasks"
                :value="true"
                color="transparent"
                class="filter-tasks"
                height="25px"
              >
                <v-btn
                  color="blue"
                  flat
                  value="all"
                >
                  <span>All</span>
                </v-btn>

                <v-btn
                  color="green"
                  flat
                  value="Closed"
                >
                  <span>Closed</span>
                </v-btn>

                <v-btn
                  color="yellow"
                  flat
                  value="In-Progress"
                >
                  <span>In-Progress</span>
                </v-btn>

                <v-btn
                  color="red"
                  flat
                  value="Open"
                >
                  <span>Open</span>
                </v-btn>
              </v-bottom-nav>
              <div class="loading-overlay" v-if="loadingTask">
                <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
              </div>
               <p class="pt-5 title font-weight-light" v-if="!Task.length">Nothing to show</p>
              <vue-perfect-scrollbar class="tasks-content">
                <template v-for="(item, index) in Task">
                  <div v-ripple :key="item.id" class="tasksList" @click="openTask(item, index)">
                    <div v-bind:class="[ item.status ? item.status.replace(' ', '-'): '' ]" class="badgeTaskStatus dark">
                      <v-icon small flat v-if="item.status && item.status.status === 'Closed'">check</v-icon>
                      <span>{{ item.status ? item.status : '' }}</span>
                    </div>
                    
                    <p class="pt-2">{{ item.name }}</p>
                    <v-icon small flat v-if="item.description">notes</v-icon>
                    <v-icon small flat v-if="item.links.length > 0">link</v-icon>
                    </div>
                </template>
              </vue-perfect-scrollbar>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex lg4 sm6 xs12 class="mb-4" v-if="isWidgetActive('Timeline')">
          <v-card hover height="100%" style="position: relative;">
            <v-card-title class="justify-space-between pf-bg-green white--text">
              <h4 xs6>Timeline</h4>
              <div xs6 class="icon">
                <v-icon large color="white">timeline</v-icon>
              </div>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="timeline-card-text">
              <div class="loading-overlay" v-if="loadingTimeline">
                <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
              </div>
               <p class="pt-5 title font-weight-light" v-if="!Timeline.length">Nothing to show</p>
              <vue-perfect-scrollbar class="timeline-content">
                <v-timeline clipped dense class="pa-1">
                  <v-timeline-item
                    v-for="(item, index) in Timeline"
                    :key="index"
                    :color="item.color"
                    :icon="item.icon"
                    right
                    fill-dot
                  >
                    <router-link to="/timelines">
                    <v-card class="elevation-2" v-ripple>
                      <v-card-title>
                        <strong>{{ item.title }}</strong>
                        <v-spacer></v-spacer>
                        <span>{{ formatDateMethod( item.createdAt) }}</span>              
                      </v-card-title>
                      <v-card-text v-if="item.title !== 'Project Video Status changed'" class="pt-0 pb-1">{{ removeHTML(item.text)}}</v-card-text>
                      <v-card-text v-if="item.title === 'Project Video Status changed'" class="pt-0 pb-1">{{ item.text.split(',')[0] }}
                        <p><a @click.stop class="VideoLinkColor" target="_blank" :href="item.text.split(',')[1]">{{ item.text.split(',')[1] }}</a></p>
                      </v-card-text>
                      <v-card-actions class="py-0">
                        <span class="caption d-block py-0 my-0"><v-icon small>access_time</v-icon> {{ moment.tz((new Date(item.createdAt)).toISOString(), moment.tz.guess()).fromNow()}}</span>
                      </v-card-actions>
                    </v-card>
                    </router-link>
                  </v-timeline-item>
                </v-timeline>
              </vue-perfect-scrollbar>
             </v-card-text>  
             <v-tooltip top>
             <v-btn slot="activator" to="/timeline/add" dark fab absolute small bottom left class="pf-bg-green composeMessageBtn">
              <v-icon>add</v-icon>
             </v-btn>
                  <span>Create new Timeline</span>
              </v-tooltip>
          </v-card>
        </v-flex>

        <v-flex lg4 sm6 xs12 class="mb-4" v-if="isWidgetActive('Messages')">
          <v-card hover height="100%" style="position: relative;">
            <v-card-title class="justify-space-between pf-bg-teal white--text" @click="goToMessages">
              <h4 xs6>Messages <span v-if="getUnreadConversationCount() > 0">({{ getUnreadConversationCount() }})</span></h4>
              <div xs6 class="icon">
                <v-icon large color="white">message</v-icon>
              </div>
            </v-card-title>
            <v-toolbar card dense flat class="white chat-room--toolbar" light>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon @click="backToList()" v-on="on">
                    <v-icon color="text--secondary">keyboard_arrow_left</v-icon>
                  </v-btn>
                </template>
                <span>Back to Conversation List</span>
              </v-tooltip>
              <template v-for="(item, index) of conversationItem.human">
                <span :key="index">{{ conversationItem.human.length > index + 1 ? item.display_name + ',' : item.display_name }}</span>
              </template>
              <v-spacer></v-spacer>              
              <v-tooltip top>
                <v-btn icon slot="activator" v-if="conversationItem.last_message" @click="replyMessage(conversationItem.last_message)">
                  <v-icon small color="text--secondary">open_in_new</v-icon>
                </v-btn>
                <span>Open message in a new window</span>
              </v-tooltip>
            </v-toolbar>
            
            <v-divider></v-divider>

            <v-card-text class="conversation_content">
              <div class="loading-overlay" v-if="loadingMessages">
                <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
              </div>
              <vue-perfect-scrollbar class="messages-conversation">
                <template v-for="(item, index) of conversationItem.message" >
                  <div v-if="item.message.human !== null" v-bind:class="[ session.user().id === item.message.createdBy ? 'reverse' : '']" class="messaging-item layout row my-4" :key="index">
                    <v-avatar class="teal mx-1" size="36">
                      <template v-if="item.message.human.account">
                        <img class="white" v-if="(item.message.human.account && item.message.human.account.avatar ? item.message.human.account.avatar : '') !== ''" :src="item.message.human.account.avatar" alt="">
                        <span v-else class="white--text subheading pa-2">
                            {{ session.user().id === item.message.createdBy ? Account.name.substr(0,2) : item.message.human.account.name.substr(0,2) }}
                        </span>
                      </template>
                      <template v-else>
                        <img class="white" v-if="(item.message.human.agency.avatar ? item.message.human.agency.avatar : '') !== ''" :src="[item.message.human.agency.avatar ? item.message.human.agency.avatar : '']" alt="">
                        <span v-else class="white--text subheading pa-2">
                          {{ session.user().id === item.message.createdBy ? item.message.human.agency.name.substr(0,2) : item.message.human.agency.name.substr(0,2) }}
                        </span>
                      </template>
                    </v-avatar>
                    <div>

                      <div class="messaging--body column mx-2">
                        <div class="message" v-html="item.message.content"></div>
                      </div>
                      <v-container py-0 ma-0 v-if="session.user().id === item.message.createdBy">
                        <v-layout row justify-space-between class="caption mb-2 text--secondary">
                          <v-flex xs4 class="pa-0 ma-0 text-xs-left seen" v-if="item.message.is_seen === true && item.message.createdBy == session.user().id" >
                            <v-icon small color="blue lighten-3">
                              fas fa-circle
                            </v-icon>
                            Seen
                          </v-flex>
                          <v-flex v-else xs4 class="pa-0 ma-0 text-xs-left seen">
                          </v-flex>
                          <v-flex xs8 class="pa-0 ma-0  text-xs-right">
                            {{ moment.tz((new Date(item.message.createdAt)).toISOString(), moment.tz.guess()).fromNow()}}
                          </v-flex>
                        </v-layout>
                      </v-container>

                      <v-container v-else py-0 ma-0>
                        <v-layout row justify-space-between class="caption mb-2 text--secondary">
                          <v-flex xs8 class="pa-0 ma-0 text-xs-left">
                            {{ moment.tz((new Date(item.message.createdAt)).toISOString(), moment.tz.guess()).fromNow()}}
                          </v-flex>
                          <v-flex xs4 class="pa-0 ma-0  text-xs-right">
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </div>
                    <v-spacer></v-spacer>
                  </div>
                </template>
              </vue-perfect-scrollbar>

              <v-expand-x-transition mode="in-out">
                <div
                  v-if="conversationList"
                  class="v-card--reveal"
                >
                  <div class="loading-overlay" v-if="loadingMessages">
                    <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                  </div>
                  <vue-perfect-scrollbar class="messages-list">
                    <p class="pt-5 mt-4 title font-weight-light" v-if="!Conversation.length">No messages received</p>
                    <v-list two-line>
                      <template v-for="(item, index) in Conversation">
                        
                        <v-list-tile
                          v-if="(item.groups && item.groups.length) || (item.human && item.human.length > 1)"
                          :key="item.title"
                          avatar
                          :class="(item.last_message && item.last_message.is_seen === false && item.last_message.createdBy !== session.user().id) ? 'unread-row' : 'read-row'"
                        >
                          <v-list-tile-avatar color="teal" v-if="(item.last_message && item.last_message.human && item.last_message.human.agency) || (item.last_message && item.last_message.human && item.last_message.human.account)">
                            <img class="white" v-if="((item.last_message.human.account && item.last_message.human.account.avatar ? item.last_message.human.account.avatar : (item.last_message.human.agency && item.last_message.human.agency.avatar ? item.last_message.human.agency.avatar : ''))) !== ''" :src="(item.last_message.human.account && item.last_message.human.account.avatar ? item.last_message.human.account.avatar : (item.last_message.human.agency && item.last_message.human.agency.avatar ? item.last_message.human.agency.avatar : ''))" alt="">
                            <span v-else class="white--text title">
                              {{ item.last_message.human.account ? item.last_message.human.account.name.substr(0,2) : (item.last_message.human.agency ? item.last_message.human.agency.name.substr(0,2) : Account.human[0].name.substr(0,2)) }}
                            </span>
                          </v-list-tile-avatar>
                          <v-list-tile-avatar color="teal" v-if="!item.last_message || item.last_message.human === null">
                            <span class="white--text title">
                              {{ item.human[item.human.length -1].display_name.substr(0, 2) }}
                            </span>
                          </v-list-tile-avatar>

                          <v-list-tile-content @click="replyConversation(item)">
                            <v-list-tile-title>
                              <v-tooltip top class="unReadList" v-if="(item.last_message && item.last_message.is_seen === false && item.last_message.createdBy !== session.user().id)" :key="'unreadIcon_' + index">
                                  <v-icon small color="blue lighten-3" slot="activator">
                                    fas fa-circle
                                  </v-icon>
                                <span>Unread message</span>
                              </v-tooltip>
                              {{item.subject}}
                              <v-spacer></v-spacer>
                            </v-list-tile-title>
                            <v-list-tile-sub-title v-if="item.last_message && item.last_message.human !== null" class="">{{ item.last_message.human.account ? item.last_message.human.account.name : (item.last_message.human.agency ? item.last_message.human.agency.name : Account.human[0].name) }} - <span class="font-weight-light font-italic">{{ item.last_message && item.last_message.content ? removeHTML(item.last_message.content) : '' }}</span></v-list-tile-sub-title>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <v-tooltip top>
                              <v-btn icon flat small class="mb-3" slot="activator" v-if="item.last_message && item.last_message.human !== null" @click="replyMessage(item.last_message)">
                                <v-icon small color="grey lighten-1">open_in_new</v-icon>
                              </v-btn>
                              <span>Open in a new window</span>
                            </v-tooltip>
                          </v-list-tile-action>
                        </v-list-tile>
                        <v-divider
                          v-if="index + 1 < Conversation.length"
                          :key="index"
                        ></v-divider>
                      </template>
                    </v-list>
                  </vue-perfect-scrollbar>
                  <v-tooltip top v-if="!session.getSession().adminUser">
                    <v-btn slot="activator" @click="messageAddPage" dark fab absolute small bottom left class="pf-bg-green composeMessageBtn">
                      <v-icon>add</v-icon>
                    </v-btn>
                    <span>Create new Message</span>
                  </v-tooltip>
                </div>
              </v-expand-x-transition>
            </v-card-text>

            <v-divider v-if="!session.getSession().adminUser"></v-divider>
            <v-card-actions class="pt-0">
              <v-text-field
                v-model="message.content"
                class="input-send-msg"
                full-width
                flat
                clearable
                solo
                dense
                append-icon="send"
                placeholder="Type some message here"
                label=""
                :disabled="conversationItem.length === 0"
                @click:append="send"
                v-if="!session.getSession().adminUser"
              >
              </v-text-field>
            </v-card-actions>         
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row justify-center>
        <v-dialog v-model="taskDialog" @input="v => v || dialogClose()" scrollable max-width="600" :persistent="!dialogActions">
          <v-card>
            <v-card-title>
              <div>
                <span class="title"><v-icon class="pr-2">subtitles</v-icon>{{ taskData ? taskData.name : '' }}</span><br>
                <span v-bind:class="[ taskData.status ? taskData.status.replace(' ', '-') : '' ]" class="badgeTaskStatus dark">
                  <span>{{ taskData.status ? taskData.status : ''}}</span>
                </span>
              </div>
            </v-card-title>
            <v-card-text class="task-dialog">
              <v-layout row wrap>
                <v-flex class="text-xs-left" xs9>
                  <h4 v-if="taskData.description">
                    <v-icon class="pr-2">subject</v-icon>
                    Description
                  </h4>
                  <template v-if="taskData.description">
                    <div id="task-description-text" class="task-description-text" v-bind:class="[ taskData.last_timeline && !taskData.description ? '' : '' ]" v-html="taskData.last_timeline && taskData.description ? taskData.description : 'Description not found'"></div>
                  </template>
                  <template v-if="taskData.links && taskData.links.length > 0">
                    <h4>
                      <v-icon class="pr-2">link</v-icon>
                      Links 
                    </h4>
                    <ul class="linkList taskLink">
                      <li v-for="(item, index) in taskData.links" :key="index">
                        <a :target="item.split('#/')[1] === 'surveys/add' ? '_self': '_blank'" :href="item">{{ item }}</a>
                      </li>
                    </ul>
                  </template>
                  <h4><v-icon class="pr-2">list</v-icon>Activities</h4>
                  <p class="pt-2 pl-4">
                    <vue-perfect-scrollbar class="activities-content">
                      <template v-for="(item, index) in taskData.timeline">
                          <div :key="index">
                            <p class="mb-0 mt-1"><span><b>{{ item.createdBy.human.name}}</b></span> - {{ removeHTML(item.text) }} </p>
                            <span class="caption">{{ formatDateMethod(item.createdAt, 'MM/DD/YYYY - hh:mm:ss')}}</span>
                          </div>
                      </template>
                    </vue-perfect-scrollbar>
                  </p>
                </v-flex>
                <v-flex xs3 pl-1 pt-0 align-end text-xs-right>
                  <v-radio-group v-model="taskStatus" @change="statusChanged();dialogActions=false" class="pt-0 mt-0">
                    <v-radio color="red" label="Open" value="Open"></v-radio>
                    <v-radio color="yellow" label="In-Progress" value="In-Progress"></v-radio>
                    <v-radio color="green" label="Closed" value="Closed"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions v-if="!dialogActions">
              <v-spacer></v-spacer>
              <v-btn class="pf-btn pf-btn-cancel" flat="flat" @click.native="taskDialog = false;cancelTaskStatus()">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" flat="flat" @click.native="taskDialog = false,saveTaskStatus();">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>

    <app-modal :active="isIntroActive" v-if="false">
      <div slot="modal-content">
        <v-card>
          <v-toolbar card dark class="pf-bg-teal">
            <v-btn class="pf-modal-close" icon dark @click="closeIntroModal">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Parentfinder Quick Tour..!</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <youtube v-if="true" :player-vars="{ autoplay: 1 }" class="pf-youtube-player" :video-id="config.introVideo" @ready="ready"></youtube>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="pf-btn-text-white pf-bg-green"
              @click="closeIntroModal"
            >
              Skip for now
            </v-btn>
            <v-btn
              class="pf-btn-text-white pf-bg-pink"
              @click="introSeen()"
            >
              Don't show again
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </app-modal>

    <!-- Popup to add new credit card -->
    <app-modal :active="showAddCardPopup" v-if="showAddCardPopup" width="30%">
      <div slot="modal-content">
        <v-card>
          <v-toolbar card dark class="pf-bg-teal">
            <v-btn class="pf-modal-close" icon dark @click="closeAddCardPopup">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Add New Card</v-toolbar-title>
          </v-toolbar>

          <v-card-text class="mt-4 mb-4">
            <v-form ref="newCardForm">
              <v-layout wrap>
                <!-- Content -->
                <v-flex xs12>
                  <v-text-field label="Card number" v-model.trim="newCardNumber" :rules="rules.card.number" class="required pr-3 pl-3 flex-center" @input="newCardChange($event)" placeholder="#### #### #### ####" :value="newCard.number" v-mask="'#### #### #### ####'" type="password">
                    <template v-slot:prepend>
                      <v-fade-transition leave-absolute>
                        <div class="pf-card-icon-single" :style="`background-image:url(/static/cards/${newCard.icon});`"></div>
                      </v-fade-transition>
                    </template>
                  </v-text-field>
                  <span v-if="newCardNumberMask" class="pf-pos-relative tm-20 ml-3">Card Number: {{ newCardNumberMask }}</span>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model.trim="newCard.name" :rules="rules.card.name" label="Card holder name" class="required pr-3 pl-3"></v-text-field>
                </v-flex>
                <v-flex xs8>
                  <v-text-field v-model.trim="newCard.expiry" :rules="rules.card.expiry" label="Expiry date" class="required pr-3 pl-3" v-mask="'## / ##'" placeholder="MM/YY"></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field v-model.trim="dummyCvv" :rules="rules.card.cvv" label="CVV" class="required pr-3 pl-3" v-mask="'####'" type="password" placeholder="CVV"></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>

          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="pf-btn-text-white pf-bg-green"
              @click="saveNewCard"
            >
              Add Card
            </v-btn>
            <v-btn
              class="pf-btn-text-white pf-bg-pink"
              @click="closeAddCardPopup"
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </app-modal>

  </div>
</template>
 
<script>
/* global session store config */
import Vue from 'vue';
import Material from 'vuetify/es5/util/colors';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Sortable from 'sortablejs';
import Mediator from '../Mediator';
import moment from 'moment-timezone';
import { mask } from 'vue-the-mask';
import { getCollection, formatDate, create, update, request, sortList, requestToWPPF, checkWPToken, conversationListPopulate, getCardType } from '../helpers/helpers';
import { mapGetters } from 'vuex';
import swal from 'sweetalert2';
import session from '../helpers/session';
import AppModal from '../components/AppModal';
import VueYouTubeEmbed from 'vue-youtube-embed';
Vue.use(VueYouTubeEmbed);

const sleep = (milliseconds) => {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
};

export default {
  components: {
    VuePerfectScrollbar,
    'app-modal': AppModal
  },
  directives: {
    sortableList: {
      bind (el, binding, vnode) {
        const options = {
          handle: 'sortHandle',
          animation: 150,
          onUpdate: function (event) {
            vnode.child.$emit('sorted', event);
          },
        };
        Sortable.create(el, options);
      },
    },
    sortableCard: {
      bind (el, binding, vnode) {
        let sortableElement = el.getElementsByTagName('tbody')[0];
        const options = {
          handle: '.sortHandle',
          animation: 150,
          onUpdate: function (event) {
            // vnode.child.$emit("sorted", event);
          },
        };
        Sortable.create(el, options);
      },
    },
    mask
  },
  data: (vm) => ({
    isIntroActive: false,
    config: config,
    albumListing: {},
    role: '',
    loadingTask: false,
    loadingMessages: false,
    loadingTimeline: false,
    color: Material,
    cardSort: [],
    selected: [2],
    ppn: '',
    membership: '',
    joinDate: '',
    conversationList: true,
    conversationAddContact: false,
    conversationId: '',
    message: {
      content: '',
      conversation: '',
      sender: ''
    },
    conversationItem: {
      message: [],
      account: ''
    },
    conversationIndex: -1,
    agencyFamiliesList: [],
    agencyAdminList: [],
    taskDialog: false,
    taskData: {
      timeline: []
    },
    taskStatus: 'Open',
    statusTaskItems: ['Closed', 'In-Progress', 'Open'],
    dialogActions: false,
    linkModel: false,
    newLink: null,
    linkIsvalid: false,
    urlRule: [ 
      v => !!v || 'URL link is required',
      v => /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/.test(v) || 'URL must be valid'
    ],
    showEditDescription: false,
    originalDescription: null,
    filterTasks: 'all',
    statusChange: false,
    accountDeepClone: {},
    player: null,
    showAddCardPopup: false,
    newCardNumber: '',
    newCardNumberMask: '',
    rules: {
      card: {
        // number: [v => !!v || 'Card number is required'],
        number: [
          // v => Number.isInteger(v) || 'Please enter an integer',
          // v => v.length <= 16 || 'Card number should not exceed 16 digits'
        ],
        name: [v => !!v || 'Card holder name is required'],
        cvv: [v => !!v || 'CVV is required'],
        expiry: [
          v => !!v || 'Card expiry is required',
          v => vm.validateDateChange(v) || 'Date is invalid or card expired'
        ],
      }
    },
    newCard: {
      name: '',
      number: '',
      expiry: '',
      icon: 'credit-card.ico',
      type: ''
    },
    dummyCvv: '',
    cardIcons: [
      { type: 'Visa', icon: 'visa.png' },
      { type: 'Mastercard', icon: 'mastercard.png' },
      { type: 'American Express', icon: 'amex.png' },
      { type: 'Diners Club', icon: 'diners-club.png' },
      { type: 'Discover', icon: 'discover.jpg' },
      { type: 'JCB', icon: 'jcb.png' },
      { type: 'Unknown', icon: 'credit-card.ico' }
    ],
  }),
  computed: {
    ...mapGetters(['Agency', 'Account', 'Task', 'Album', 'TimelineIcons']),
    MenuSettings: {
      set (value) {
        store.commit('setMenuSettings', value);
      },
      get () {
        return store.state.MenuSettings;
      }
    },
    File: {
      set (value) {
        store.commit('setFile', value);
      },
      get () {
        return store.state.File;
      }
    },
    FileLoaded: {
      set (value) {
        store.commit('setFileLoaded', value);
      },
      get () {
        return store.state.FileLoaded;
      }
    },
    PdfTemplate: {
      get () {
        return store.state.PdfTemplate;
      },
      set (value) {
        store.commit('setPdfTemplate', value);
      }
    },
    PdfTemplateLoaded: {
      get () {
        return store.state.PdfTemplateLoaded;
      },
      set (value) {
        store.commit('setPdfTemplateLoaded', value);
      }
    },
    Conversation: {
      get () {
        return store.state.Conversation;
      },
      set (value) {
        store.commit('setConversation', value);
      }
    },
    ConversationLoaded: {
      get () {
        return store.state.ConversationLoaded;
      },
      set (value) {
        store.commit('setConversationLoaded', value);
      }
    },
    Message: {
      get () {
        return store.state.Message;
      },
      set (value) {
        store.commit('setMessage', value);
      }
    },
    helpVideoList: {
      get () {
        return store.state.VideoList;
      },
      set (value) {
        store.commit('setVideoList', value);
      }
    },
    HelpVideoLoaded: {
      get () {
        return store.state.HelpVideoLoaded;
      },
      set (value) {
        store.commit('setHelpVideoLoaded', value);
      }
    },
    albumList: {
      get () {
        return store.state.Album;
      },
      set (value) {
        store.commit('setAlbum', value);
      }
    },
    AlbumLoaded: {
      get () {
        return store.state.AlbumLoaded;
      },
      set (value) {
        store.commit('setAlbumLoaded', value);
      }
    },
    Timeline: {
      get () {
        return store.state.Timeline;
      },
      set (value) {
        store.commit('setTimeline', value);
      }
    },
    TimelineLoaded: {
      get () {
        return store.state.TimelineLoaded;
      },
      set (value) {
        store.commit('setTimelineLoaded', value);
      }
    },
    IsSubscriptionActive: {
      get () {
        return store.state.IsSubscriptionActive;
      },
      set (value) {
        store.commit('setIsSubscriptionActive', value);
      }
    },
    IsSubscriptionActiveLoaded: {
      get () {
        return store.state.IsSubscriptionActiveLoaded;
      },
      set (value) {
        store.commit('setIsSubscriptionActiveLoaded', value);
      }
    },
    PaymentMode: {
      get () {
        return store.state.PaymentMode;
      },
      set (value) {
        store.commit('setPaymentMode', value);
      }
    },
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  watch: {
    filterTasks (item) {
      if (item === 'all') {
        store.commit('setTask', this.taskOriginal);
      } else {
        let newTasks = this.taskOriginal.filter(task => task.status === item);
        store.commit('setTask', newTasks);
      }
    },
    Conversation (value) {
      this.Conversation = value;
      if (this.conversationIndex > -1) {
        this.conversationItem = this.Conversation.find(item => item.id === this.conversationId);
        this.conversationIndex = this.Conversation.indexOf(this.conversationItem);
        // Read the new messages
        this.updateReadStatus();
      }
    }
  },
  created () {
    if (document.getElementById('pageHeader')) {
      window.getApp.$vuetify.goTo(document.getElementById('pageHeader').offsetTop - 70);
    }
    // Make the intro video active if not seen before
    if (this.Account && (!this.Account.settings || !this.Account.settings.intro_seen)) {
      this.isIntroActive = true;
    }
    this.initializeConversation();
    this.getTasks();
    this.getMembershipSubscription();
    this.getTimeLines();
    this.membership = this.Account.membership;
    this.ppn = this.Account.ppn;
    this.joinDate = formatDate(this.Account.createdAt, 'MM/DD/YYYY');
    this.initialize();
    this.initializePdfTemplate();
    this.initializeHelpVideos();
    this.initializeAlbum();
  },
  // mounted () {
  //   let self = this;
  //   setTimeout(function () {
  //     self.loadingMessages = false;
  //   }, 3000);
  // },
  async mounted () {
    
    window.getApp.$on('NEW_ALBUM_PHOTO', messageEvent => {
      console.log('------------>>>>>>>', 'Profile/Banner Photo', messageEvent);
      if (messageEvent.data) {
        let albumId = messageEvent.data.album;
        let newImages = messageEvent.data;
        let existingAlbumImage = false;
        if (this.Account.avatar_album === albumId) {
          if (newImages.approved) {
            this.Account.avatar = newImages.thumb_url;
          } else {
            this.Account.temp_avatar = newImages.thumb_url;
          }

          let newAlbumPhoto = {
            photo: newImages.id,
            sort_no: 0
          };
          const albumIndex = this.albumListing.findIndex(item => item.id === albumId);
          if (this.albumListing[albumIndex] && this.albumListing[albumIndex].photo.find(item => item.photo === newImages.id)) {
            existingAlbumImage = true;
          }
          if (albumIndex > -1) {
            if (this.albumListing[albumIndex].photo.length === 0) {
              this.albumListing[albumIndex].default_photo = { ...newImages };
            }
            if (!existingAlbumImage) {
              this.albumListing[albumIndex].photo.push(newAlbumPhoto);
            }
          }
          store.commit('setAlbum', this.albumListing);

        } else if (this.Account.banner_album === albumId) {

          if (newImages.approved) {
            this.Account.banner_photo = newImages.original_url;
          } else {
            this.Account.temp_banner = newImages.original_url;
          }
        } else if (this.Account.mobile_banner_album && this.Account.mobile_banner_album === albumId) {
          if (newImages.approved) {
            this.Account.mobile_banner = newImages.original_url;
          } else {
            this.Account.temp_mobile_banner = newImages.original_url;
          }
        } else {
          let albumIndex = this.albumList.findIndex(item => item.id === albumId);
          if (albumIndex === -1) {
            this.getAlbums();
          }
        }
        store.commit('setAccount', this.Account);
      }
    });
  },
  methods: {
    isWidgetActive (widget) {
      if (widget) {
        let widgetIndex = null;
        let widgetStatus = null;
        if (this.MenuSettings && this.MenuSettings.dashboard_settings && this.MenuSettings.dashboard_settings.length) {
          widgetIndex = this.MenuSettings.dashboard_settings.findIndex(x => x.name === widget);
          if (widgetIndex > -1) {
            widgetStatus = this.MenuSettings.dashboard_settings[widgetIndex].status;
            if (widgetStatus === 'on') {
              return true;
            } else if (widgetStatus === 'off') {
              return false;
            } else if (widgetStatus === 'on_until_live') {
              return !(this.Account.agency && this.Account.agency.length && this.Account.agency.filter(y => y.status === 'Active').length);
            }
          }
        }
      }
      return true;
    },
    messageAddPage () {
      this.$router.push({ name: 'addMessage', query: { preUrl: 'dashboard' }});
    },
    goToMessages () {
      this.$router.push({ name: 'Messages' });
    },
    dialogClose () {
      this.dialogActions = false;
    },
    ready (event) {
      this.player = event.target;
    },
    closeIntroModal () {
      this.player.stopVideo();
      this.isIntroActive = false;
      window.getApp.$emit('ChangeAppModalStatus', false);
    },
    cancelMembership () {
      swal.fire({
        title: 'Are you sure?',
        text: 'Are you sure that you want to cancel the membership subscription?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, cancel it!'
      }).then(async (result) => {
        if (result.value) {
          (async () => {
            let payload = {
              account: this.Account.id,
              subscription_type: 'Membership'
            };
            let { error, data } = await request('PaymentSubscription/Cancel', 'PUT', payload);
            if (error) {
              console.log('error', error);
              swal.fire({
                type: 'warning',
                title: 'Error',
                text: typeof error === 'string' ? error : (error.message || 'Something went wrong, please check with your agency'),
                showConfirmButton: true,
                onClose: () => {}
              });
              return;
            } else {
              /* Update the membership status in state */
              this.IsSubscriptionActive = false;
              swal.fire({
                type: 'success',
                title: 'Success',
                text: 'Your membership subscription was cancelled',
                showConfirmButton: false,
                timer: 2500,
                onClose: () => {
                  // 
                }
              });
            }
          })();
        }
      });
    },
    async introSeen () {
      this.closeIntroModal();
      if (this.Account) {
        if (this.Account.settings) {
          this.Account.settings.intro_seen = true;
        } else {
          this.Account.settings = { intro_seen: true };
        }
        let { error, data, status } = await this.updateAccount();
        if (error) {
          console.log('error', error);
        } else {
          store.commit('setAccount', data);
        }
      }
    },
    async upgradeMembership (newMembership) {
      if (newMembership && typeof this.Account.mapping_id !== 'undefined' && await checkWPToken()) {
        let payload = {
          new_membership: newMembership
        };
        let upgradeUrl = config.WPParams.api.url + 'pf/v1/user/updateMembership/' + this.Account.mapping_id;
        let response = await requestToWPPF(upgradeUrl, 'PUT', payload);
        if (response.error) {
          swal.fire({
            type: 'warning',
            title: '<b>Error</b>',
            html: response.message,
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              // 
            }
          });
          return;
        } else {
          this.Account.membership = this.membership = newMembership;
          swal.fire({
            type: 'success',
            title: '<b>Upgraded</b>',
            html: response.message,
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              // 
            }
          });
        }
      }
    },
    async cancelTaskStatus () {
      if (this.statusChange) {
        this.taskData = {
          timeline: []
        };
        this.statusChange = false;
        store.commit('setAccount', this.accountDeepClone);
        this.getTasks();
      }
    },
    async saveTaskStatus () {
      if (this.statusChange) {
        let Task = await this.Account.task.filter(task => task._id === this.taskData._id);
        Task[0].status = this.taskStatus;
        let TaskIndex = await this.Account.task.findIndex(task => task._id === this.taskData._id);
        this.Account.task.splice(TaskIndex, 1, Task[0]);
        this.Account.updated_from = 'tasks';
        let { error, data, status } = await this.updateAccount();
        if (error) {
          console.log('error', error);
        } else {
          store.commit('setAccount', data);
          this.loading = false;
          swal.fire({
            type: 'success',
            title: 'Details saved successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.setStatus(this.taskStatus);
            }
          });
        }
      }
    },
    async updateAccount () {
      if (this.Account && session.isOnline()) {
        let response = await update('Account', this.Account, session.getSession().user.human.account.id);
        return response;
      }
    },
    statusChanged (e) {
      this.accountDeepClone = JSON.parse(JSON.stringify(this.Account));
      this.taskData.status = this.taskStatus;
      this.statusChange = true;
    },
    getHumanId (messageId) {
      let humanObj = this.Message.find(message => message.id === messageId);
      if (humanObj) {
        return humanObj.createdBy;
      }
    },  
    formatDateMethod (date, format = 'MM/DD/YYYY') {
      return formatDate(date, format);
    },
    async initialize () {
      if (!this.File.length && !this.FileLoaded) {
        let entity = 'File';
        let sessionUser = session.getSession();
        let where = sessionUser.adminUser ? { account: sessionUser.user.human.account.id } : {};
        let { error, data } = await getCollection(entity, true, 0, '', where);
        if (error) {
          console.log(error);
        } else {
          this.FileLoaded = true;
          this.File = data;
        }
      }
    },
    async initializePdfTemplate () {
      if (!this.PdfTemplate.length && !this.PdfTemplateLoaded) {
        let entity = 'PdfTemplate';
        let sessionUser = session.getSession();
        let where = sessionUser.adminUser ? { account: sessionUser.user.human.account.id } : {};
        let { error, data } = await getCollection(entity, true, 0, '', where);
        if (error) {
          console.log(error);
        } else {
          this.PdfTemplateLoaded = true;
          this.PdfTemplate = data;
        }
      }
    },
    async initializeConversation () {
      if (!this.Conversation.length && !this.ConversationLoaded) {
        this.conversationItem = {};
        this.loadingMessages = true;
        let entity = 'Conversation';
        let sort = { 'updatedAt': -1 };
        let sessionUser = session.getSession();
        let where = {};
        where = {
          $and: [
            {
              $or: [
                {
                  human: sessionUser.user.human.id
                }
              ]
            },
            {
              $or: [
                {
                  archive: { $exists: false }
                },
                {
                  archive: {
                    $ne: sessionUser.user.human.id
                  }
                }
              ]
            },
            {
              $or: [
                {
                  removed: { $exists: false }
                },
                {
                  removed: {
                    $ne: sessionUser.user.human.id
                  }
                }
              ]
            }
          ]
        };
        if (sessionUser.user.human.group && sessionUser.user.human.group.length) {
          where.$and[0].$or.push({
            groups: {
              $in: sessionUser.user.human.group && sessionUser.user.human.group.length ? sessionUser.user.human.group.map(group => group.group) : []
            }
          });
        }
        let { error, data } = await getCollection('Conversation', true, 0, await conversationListPopulate(sessionUser.user.human.id), where, null, null, sort, true);
        if (error) {
          console.log(error);
        } else {
          this.ConversationLoaded = true;
          if (data.length > 0) {
            this.Conversation = data;
            setTimeout(() => {
              const container = this.$el.querySelector('.ps-container.messages-conversation');
              container.scrollTop = container.scrollHeight;
              this.loadingMessages = false;
            }, 0);
            
          } else {
            this.loadingMessages = false;
          }
        }
      }
    },
    async replyConversation (conversation) {
      this.conversationId = conversation.id;
      this.conversationItem = this.Conversation.find(item => item.id === this.conversationId);
      this.conversationIndex = this.Conversation.indexOf(this.conversationItem);
      
      this.conversationList = false;
      await this.updateReadStatus();
    },
    async initializeAlbum () {
      if (!this.albumList.length && !this.AlbumLoaded) {
        this.getAlbums();
      }
      this.albumListing = JSON.parse(JSON.stringify(this.albumList));
    },
    async getAlbums () {
      let entity = 'Album';
      let sessionUser = session.getSession();
      let where = sessionUser.adminUser ? { account: sessionUser.user.human.account.id } : {};
      let { error, data } = await getCollection(entity, true, 0, '', where, null, null, {}, true);
      if (error) {
        console.log('error', error);
      } else {
        this.AlbumLoaded = true;
        if (data.length > 0) {
          this.albumList = sortList(entity, data, 'Account', sessionUser.adminUser ? sessionUser.user.human.account.id : 'Me');
        }
      }
    },
    async getTasks () {
      this.loadingTask = true;
      let tasks = this.Account.task;
      let sessionUser = session.getSession();
      if (tasks.length > 0) {
        store.commit('setTask', tasks);
      }
      this.taskOriginal = tasks;
      this.loadingTask = false;
    },
    async setStatus (status) {
      // if (this.taskData.last_timeline.status !== status) {
      let timelineObj = {};
      switch (status) {
        // eslint-disable-next-line no-case-declarations
        case 'Closed':
          this.taskData.last_timeline.status = status;
          timelineObj = {
            'text': `You completed the task '${this.taskData.name}'`,
            'title': 'Task Completed',
            'task': this.taskData._id,
            'status': status,
            'description': this.taskData.description ? this.taskData.description : '',
            'links': this.taskData.last_timeline.links ? this.taskData.last_timeline.links : [],
            'icon': 'check',
            'color': 'green',
          };
          // let obj = {
          //   'task': this.taskData.id,
          //   'datetime': new Date().toISOString()
          // };

          // this.Account.task.push(obj);
          this.updateTimeline(timelineObj, status);
          break;
        case 'In-Progress':
          this.taskData.last_timeline.status = status;
          timelineObj = {
            'text': `You started the task '${this.taskData.name}'`,
            'title': 'Task Started',
            'task': this.taskData._id,
            'status': status,
            'description': this.taskData.description ? this.taskData.description : '',
            'links': this.taskData.last_timeline.links ? this.taskData.last_timeline.links : [],
            'icon': 'hourglass_empty',
            'color': 'orange',
          };
          this.updateTimeline(timelineObj, status);
          break;

        case 'Open':
          this.taskData.last_timeline.status = status;
          timelineObj = {
            'text': `You updated the task '${this.taskData.name}' into Open`,
            'title': 'Task Updated',
            'task': this.taskData._id,
            'status': status,
            'description': this.taskData.description ? this.taskData.description : '',
            'links': this.taskData.last_timeline.links ? this.taskData.last_timeline.links : [],
            'icon': 'edit',
            'color': 'blue',
          };
          this.updateTimeline(timelineObj, status);
          break;
       
        default:
          timelineObj = {
            'text': `${this.taskData.name}`,
            'task': this.taskData.id,
            'description': this.taskData.description,
            'status': this.taskData.last_timeline.status,
            'links': this.taskData.last_timeline.links,
            'icon': 'new_releases',
            'color': 'orange',
          };
          this.updateTimeline(timelineObj);
          break;
      }
      // }
    },
    async updateTimeline (timelineObj) {
      if (session.getSession().adminUser) {
        timelineObj.account = session.getSession().user.human.account.id;
      }
      let { error, data } = await create('Timeline', timelineObj);
      if (error) {
        console.log('error', error);
      } else {
        let newTimelineItem = Object.assign(data, timelineObj);

        if (this.taskData.last_timeline && !this.taskData.last_timeline._id) {
          this.taskData.last_timeline = newTimelineItem;
          this.Task[this.taskData.index].last_timeline = newTimelineItem;
        }

        timelineObj.text = this.taskData.last_timeline.text;
        let result = await update('Timeline', timelineObj, this.taskData.last_timeline.id);
        if (result.error) {
          console.log('result.error', error);
        } else {
          let newTimelineItem = Object.assign(result.data, timelineObj);

          if (!this.taskData.last_timeline) {
            this.taskData.last_timeline = newTimelineItem;
            this.Task[this.taskData.index].last_timeline = newTimelineItem;
          }
        }
        this.Timeline.unshift(newTimelineItem);
        this.statusChange = false;
        this.getTasks();
      }
    },
    async openTask (task, index) {
      this.taskData = Object.assign({}, task);
      await this.getTasksTimelines(index);
      this.loadingTask = false;
      this.taskData.index = index;
      this.taskStatus = this.taskData.status;
      this.taskDialog = true;
      if (this.taskData.status === 'Open') {
        swal.fire({
          title: 'Are you starting this task?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          allowOutsideClick: false
        }).then(async (result) => {
          if (result.value) {
            this.dialogActions = true;
            this.taskStatus = 'In-Progress';
            await this.statusChanged();
            await this.saveTaskStatus();
            this.statusChange = false;
          }
        });
      }
    },
    async getTasksTimelines (index) {
      if (!this.Task[index].last_timeline) {
        this.loadingTask = true;
        let sessionUser = session.getSession();
        let entity = `Timeline`;
        let sort = { 'createdAt': -1 };
        let where = sessionUser.adminUser ? { $and: [{ account: sessionUser.user.human.account.id }, { 'task': this.taskData._id }] } : { 'task': this.taskData._id };
        let result = await getCollection(entity, true, 0, '', where, null, null, sort, true);
        if (result.error) {
          console.log(result.error);
        } else {
          if (result.data.length > 0) {
            this.Task[index].timeline = Object.assign({}, result.data);
            this.Task[index].last_timeline = result.data[result.data.length - 1];
          // tasks[index].last_timeline = result.data.find(timeline => timeline.text.includes('Created a new Timeline'));
          } else {
            this.Task[index].timeline = [];
            this.Task[index].last_timeline = { status: 'Open', links: [] };
          }
          this.taskData.timeline = this.Task[index].timeline;
          this.taskData.last_timeline = this.Task[index].last_timeline;
          store.commit('setTask', this.Task);
        }
      }
    },
    async getTimeLines (fetchAll = false) {
      // This is fetched all the time now as the mediator not integrated
      if ((!this.Timeline.length && !this.TimelineLoaded) || fetchAll) {
        this.loadingTimeline = true;
        let entity = `Timeline`;
        let sessionUser = session.getSession();
        let sort = { 'createdAt': -1 };
        let where = sessionUser.adminUser ? { account: sessionUser.user.human.account.id } : {};
        let limit = 10;
        let { error, data, count } = await getCollection(entity, fetchAll, limit, 'account', where, null, null, sort, fetchAll);
        if (error) {
          console.log(error);
        } else {
          this.TimelineLoaded = true;
          if (data.length > 0) {
            
            data.forEach((timeline, i) => {
  
              if (typeof this.TimelineIcons[timeline.title] !== 'undefined') {
                data[i].icon = this.TimelineIcons[timeline.title].icon;
                data[i].color = this.TimelineIcons[timeline.title].color;
              } else {
                data[i].icon = 'new_releases';
                data[i].color = 'orange';              
              }
            });
            this.loadingTimeline = false;
            store.commit('setTimeline', data);

            /* Load the remaining items if exists */
            if (!fetchAll && count > limit) {
              this.getTimeLines(true);
            }
          } else {
            this.loadingTimeline = false;
          }
          this.loadingTimeline = false;
        }
      }
    },
    async getMembershipSubscription () {
      if (!this.IsSubscriptionActiveLoaded) {
        let where = {
          account: this.Account.id,
          type: 'Membership',
          status: 'Subscribed'
        };
        let { error, data, count } = await getCollection('PaymentSubscription', true, 0, '', where);
        if (error) {
          console.log(error);
        } else {
          this.IsSubscriptionActiveLoaded = true;
          if (data.length > 0) {
            this.IsSubscriptionActive = true;
          }
        }
      }
    },
    async initializeHelpVideos () {
      if (!this.helpVideoList.length && !this.HelpVideoLoaded) {
        if (typeof this.Account.membership !== 'undefined') {
          let where = { membership: this.Account.membership };
          let sort = { sort_no: 1 };
          let { error, data } = await getCollection('HelpVideo', true, 0, '', where, null, null, sort);
          if (error) {
            console.log(error);
          } else {
            this.HelpVideoLoaded = true;
            if (data.length > 0) {
              this.helpVideoList = data;
            }
          }
        }
      }
    },
    replyMessage (item) {
      this.$router.push({ path: '/message/reply/' + item.conversation, query: { preUrl: 'dashboard' }});
    },
    removeHTML (text) {
      let strippedText = text.replace(/(<([^>]+)>)/ig, '');
      return strippedText;
    },
    backToList () {
      this.conversationList = !this.conversationList;
      this.conversationIndex = -1;
    },
    /* eslint max-depth: [2, 6] */
    getUnreadConversationCount () {
      let unReadCount = 0;
      let conversationList = this.Conversation;
      if (conversationList) {
        for (let i = 0; i < conversationList.length; i++) {
          let messageList = conversationList[i].message;
          let unReadMessageCount = 0;
          if (messageList) {
            for (let j = 0; j < messageList.length; j++) {
              if (messageList[j]) {
                if (messageList[j].message && messageList[j].message.createdBy !== session.user().id && messageList[j].message.is_seen === false) {
                  unReadMessageCount++;
                }
              }
            }
          }
          if (unReadMessageCount > 0) {
            unReadCount++;
          }
        }        
      }
      return unReadCount;
    },
    async updateReadStatus () {
      // Update if logged in user is the recipient
      if (!session.getSession().adminUser) {
        this.conversationItem.message.forEach(async (element, index) => {
          if (element.message && element.message.human && element.message.createdBy !== session.user().id && element.message.is_seen === false) {
            element.message.is_seen = true;
            let updateData = JSON.parse(JSON.stringify(element.message));
            updateData.human = updateData.human.id;
            let { error, data, status } = await update('Message', updateData, updateData.id);
            if (error) {
              console.log('error', error);
            } else {
              this.conversationItem.message[index].message.is_seen = true;
            }
          }   
        });
        if (this.conversationItem.last_message) {
          this.conversationItem.last_message.is_seen = true;
        }
      }
    },
    async send () {
      if (this.message.content) {
        this.selectedData = false;
        this.message.conversation = this.conversationId;
        this.message.sender = this.Account.human[0].id;
        let { error, data, status } = await create('Message', this.message);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          let messageData = {};
          let humanData = {
            account: {
              avatar: this.Account.avatar,
              id: this.Account.id,
              name: this.Account.name,
              ppn: this.Account.ppn,
              _id: this.Account._id
            },
            birth_date: this.Account.human[0].birth_date,
            id: this.Account.human[0].id,
            user: this.Account.human[0].user,
            _id: this.Account.human[0]._id
          };
          data.human = humanData;
          messageData.message = data;
          this.Conversation[this.conversationIndex].message.push(messageData);
          this.Conversation[this.conversationIndex].last_message = data;          
          swal.fire({
            type: 'success',
            title: 'Message sent successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.message.content = '';
              // this.$router.push({ path: '/messages' });
            }
          });

          setTimeout(() => {
            const container = this.$el.querySelector('.ps-container.messages-conversation');
            container.scrollTop = container.scrollHeight;
          }, 0);
        }
      }
    },
    templateClick () {
      if (this.Account.agency && this.Account.agency.length && this.Account.agency.filter(x => x.status === 'Active').length) {
        this.$router.push({ path: '/websiteTemplates' });
      } else {
        swal.fire({
          type: 'warning',
          title: 'Not Active',
          text: `Your profile needs to be in Active status to access this feature, please contact your agency.`,
          showConfirmButton: true,
          onClose: () => {
            // 
          }
        });
        return;
      }
    },
    addNewCard () {
      this.showAddCardPopup = true;
      this.dummyCvv = '';
    },
    newCardChange (newValue) {
      this.newCard.number = newValue.replace(/ /g, '');
      if (this.newCard.number && this.newCard.number.trim() && this.newCard.number.replace(' ', '')) {
        let cardType = getCardType(this.newCard.number.replace(' ', ''));
        let index = this.cardIcons.findIndex(y => y.type === cardType);
        if (index > -1) {
          this.newCard.icon = this.cardIcons[index].icon;
          this.newCard.type = cardType;
        }
      }
      this.newCardNumberMask = this.newCard.number.replace(' ', '').replace(/.(?=.{4})/g, '#').match(/.{1,4}/g).join(' ');
    },
    validateDateChange (value) {
      if (value && value.trim()) {
        let splited = this.newCard.expiry.trim().split(' / ');
        if (parseInt(splited[0], 10) > 12 || parseInt(splited[0], 10) < 1) {
          return false;
        }
        let currentYear = (new Date()).getFullYear();
        let currentMonth = (new Date()).getMonth() + 1;
        let lastTwo = currentYear.toString().substr(2);
        if (parseInt(splited[1], 10) < lastTwo || (parseInt(splited[1], 10) === lastTwo && currentMonth)) {
          return false;
        }
      }
      return true;
    },
    closeAddCardPopup () {
      this.showAddCardPopup = false;
      this.newCardNumber = '';
      this.newCardNumberMask = '';
      this.newCard = {
        name: '',
        number: '',
        expiry: '',
        icon: 'credit-card.ico',
        type: ''
      };
    },
    async saveNewCard () {
      if (this.$refs.newCardForm.validate()) {
        if (this.newCard) {
          let payload = { card: JSON.parse(JSON.stringify(this.newCard)) };
          delete payload.card.icon;
          /* format the card number and expiry */
          payload.card.number = payload.card.number.replace(/ /g, '');
          payload.card.expiry = payload.card.expiry.replace(' / ', '');
          payload.card.type = payload.card.type ? payload.card.type : 'Unknown';
          payload.account = this.Account.id;
          let { error, data } = await create('PaymentMode', payload);
          if (error) {
            console.log(error);
            swal.fire({
              type: 'warning',
              title: 'Error',
              text: `${error.message || error}, please try again. If problem persists please contact support at support@parentfinder.com`,
              showConfirmButton: true,
              onClose: () => {
                this.newCard = {
                  name: '',
                  number: '',
                  expiry: '',
                  icon: 'credit-card.ico',
                  type: ''
                };
              }
            });
          } else if (data) {
            this.PaymentMode.push(data);
            
            let cardType = getCardType(data.card.number);
            let index = this.cardIcons.findIndex(y => y.type === cardType);
            let icon = 'credit-card.ico';
            if (cardType && index > -1) {
              icon = this.cardIcons[index].icon;
            }
            this.newCard = {
              name: '',
              number: '',
              expiry: '',
              icon: 'credit-card.ico',
              type: ''
            };
            this.showAddCardPopup = false;
            /* Set the authorize_profile in account if not exists */
            if (!this.Account.authorize_profile && data.authorizeNetProfile) {
              this.Account.authorize_profile = data.authorizeNetProfile;
            }
            swal.fire({
              type: 'success',
              title: 'Your card was added successfully',
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                // 
              }
            });
          }
        }
      }

    },
  }
};
</script>

<style scoped lang="css">
.v-list__tile__sub-title >>> p {
  margin-bottom: 0 !important;
}
.tasksList {
  padding: 10px;
  border-radius: .25rem;
  margin: 15px 5px;
  background-color: #fff;
  transition: all .3s cubic-bezier(.23,1,.32,1);
  box-shadow: 0 1px 3px 0 rgba(0,0,0,.1), 0 1px 2px 0 rgba(0,0,0,.06);
  position: relative;  
  text-align: left;
}
.tasksList:hover {
  background: rgb(245, 245, 245);
}
.tasksList .v-list__tile__action {
  min-width: 0;
}
a {
  text-decoration: none;
}
.tasks-content .v-list {
  margin: 0 5px;
  padding: 0px
}
.tasks-content {
  padding: 0px 10px 10px 10px;
}
.tasks-card-text {
  padding: 0px;
  height: 455px !important;
}
.timeline-card-text {
  padding-right: 0px
}
.tasks-content, .timeline-content, .messages-content {
  height: 420px;
}
.filter-tasks {
  box-shadow: none;
}
.v-timeline--dense .v-timeline-item__body {
    max-width: calc(100% - 50px) !important;
}
.activities-content {
  height: 326px;
}
.v-item-group.v-bottom-nav .v-btn {
  border-radius: 1.25rem;
  display: inline-block;
  padding: 0px 15px;
  font-size: 11px;
  color: #fff;
}
.badgeTaskStatus {
  border-radius: 1.25rem;
  display: inline-block;
  padding: 0px 15px;
  font-size: 11px;
  color: #fff;
}
.Open {
  background-color: #F44336 !important;
}
.Closed {
  background-color: #4caf50 !important;
}
.In-Progress {
  background-color: #FFEB3B !important;
  color: #333 !important;
}
.task-edit-description {
  font-size: 14px;
  padding-left: 35px;
}
.task-edit-description >>> textarea {
  margin: 10px 0px 0px 12px;
}
.task-dialog {
  max-height: 100% !important;
}
.task-description-text {
  padding: 16px 0px 16px 0px;
  margin-left: 35px;
}
.task-description-text pre{
  font-family: inherit !important;
}
.task-description-empty {
  padding: 16px 0px 16px 24px;
  background-color: #f3f3f3;
  border-radius: .25rem;
}
.task-description-empty:hover {
  background-color: #e8e8e8;
}
.btn-save-description {
  margin: -25px 0px 5px 34px;
}
.linkList {
    list-style: none;
    padding-left: 36px;
    padding-bottom: 20px;
}
.messages-list {
  height: 450px;
}
.messages-content {
  height: 255px;
}
.messages-conversation {
  height: 340px;
}
.v-list__tile__action.sortHandle{
  display: contents !important;
}
.v-list__tile__action{
  position: absolute;
  right: 15px;
}
.v-card__title.sortHandle{
  cursor: move;
}
.v-card__text {
  max-height: 455px;
  height: 100%;
  text-align: center;
  position: relative;
}
.v-card__text h4 {
  font-size: 17px;
}
.conversation_content {
  max-height: 360px;
  padding: 5px
}
.input-send-msg >>> .v-input__slot {
  min-height: 30px !important;
}
.v-card__actions{
  display: block !important;
  text-align: center;
  height: 52px;
}
.v-timeline-item {
  padding-right: 10px;
}
.v-timeline-item .v-card__text {
  max-height: 280px;
  height: 100%;
  text-align: left;
  position: relative;
  padding-top: 0px;
}
.v-timeline-item .v-card {
  border-radius: .25rem;
}
.v-timeline-item .v-card a {
  color: #64B5F6 !important;
  word-break: break-all;
}
.v-timeline-item .v-timeline-item__body {
  max-width: calc(100% - 40px) !important;
}
.v-timeline-item .v-card__actions {
  height: 25px;
  text-align: end;
  color: rgb(99, 96, 96);
}
.v-timeline-item .v-card__actions .v-icon {
  font-size: 14px !important;
}
.v-timeline-item .v-card__title span {
  font-size: 12px !important;
  color: rgb(99, 96, 96);
}
.loading-overlay {
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
}
.composeMessageBtn {
  position: absolute;
  top: auto;
  bottom: -25px;
  left: auto;
  right: -5px;
}
.fontWeight-300 {
  font-weight: 300;
}
.message-list {
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 1px;
  margin-top: 1px;
}
.messaging--body {
  padding: 10px 0px;
  margin-top: 2px !important;
  border-radius: 0rem 1.25rem 1.25rem 1.25rem;
  margin: 15px 5px;
  background-color: #64B5F6;
  color: #fff;
  transition: all .3s cubic-bezier(.23,1,.32,1);
  box-shadow: 0 1px 3px 0 rgba(0,0,0,.1), 0 1px 2px 0 rgba(0,0,0,.06);
  position: relative;
  min-width: 150px;
}
.reverse .messaging--body {
  border-radius: 1.25rem 0rem 1.25rem 1.25rem;
  background-color: #ECECEC;
  color: #333;
  box-shadow: 0 1px 3px 0 rgba(0,0,0,.1), 0 1px 2px 0 rgba(0,0,0,.06);
}
.messaging--title {
  padding: 0px 0px 5px 15px;
  text-align: start;
  overflow: auto;
}
.messaging--title .messageRead{
  float: right;
  margin-right: 10px;
}
.messaging--title .human {
  font-size: 14px;
  font-weight: bold;
}
.messaging--title .time {
  font-size: 12px;
  display: inline-block;
}
.messaging-item {
  margin: 0px !important;
}
.messaging--body .message {
  margin: 0px 15px;
  text-align: left;
}
.messaging--body .message >>> img{
  width: 160px !important;
}
.seen .v-icon{
  font-size: 6px !important;
  vertical-align: middle;
}
.seen {
  color: #64B5F6;
}
.unReadList {
  /* position: absolute;
  right: 0px;
  padding: 15px 10px; */
  vertical-align: text-bottom;
}
.unReadList .v-icon{
  font-size: 10px !important;
 }
 .v-list__tile__title {
   font-size: 14px !important;
 }
 .v-list__tile__sub-title {
   font-size: 13px !important;
 }
 .unread-row .v-list__tile__title, .unread-row .v-list__tile__sub-title {
  font-weight: 800 !important;
 }
 .v-card--reveal, .v-card--add-contact {
  z-index: 1;
  top: -51px;
  right: 0;
  bottom: 0;
  position: absolute;
  width: 100%;
  background-color: #fff;
  height: max-content;
}
.avatar-chat {
  margin-left: -10px;
  -webkit-box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
  box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
}
.chat-room--toolbar {
  min-height: 48px !important;
}
.chat-room--toolbar .v-toolbar__title{
  font-size: 16px;
  font-weight: 400;
  white-space: normal;
  text-align: center;
}
.link {
    color: #019d8c !important;
}

.v-card__actions .v-btn {
    margin: 0 8px;
    min-width: 105px;
}
.text-truncate {
  line-height: inherit !important;
}

.taskLink a {
    color: #019d8c !important;
}

.v-item-group.v-bottom-nav .v-btn {
  min-width:60px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue